// extracted by mini-css-extract-plugin
export default {"Section":"AccordionSection_Section__XAwOq","Header":"AccordionSection_Header__fsx09","Chevron":"AccordionSection_Chevron__vY4PP","Body":"AccordionSection_Body__F+Rrd"};